import { render, staticRenderFns } from "./PostAdoptLayout.vue?vue&type=template&id=422d4923&scoped=true&"
import script from "./PostAdoptLayout.vue?vue&type=script&lang=js&"
export * from "./PostAdoptLayout.vue?vue&type=script&lang=js&"
import style0 from "./PostAdoptLayout.vue?vue&type=style&index=0&id=422d4923&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422d4923",
  null
  
)

export default component.exports